module.exports = __webpack_public_path__ + "img/indus-pic-6.e76efec5.png";